export default (theme) => ({
  root: {
    paddingRight: 60,
    minHeight: theme.spacing(3),
  },
  rootFixedHeight: {
    paddingRight: 60,
    overflow: 'scroll',
    maxHeight: 50,
    minHeight: theme.spacing(3),
    scrollBehavior: 'smooth',
  },
  btn: {
    position: 'absolute',
    right: 20,
    padding: 0,
    top: (props) => (props.isArrowOnTop ? 0 : 36),
    color: theme.color.black,
  },
  summary: {
    lineHeight: `${theme.spacing(3)}px`,
    position: 'relative',
    zIndex: 1,
  },
  expanded: {
    transform: 'rotate(180deg)',
  },
  contactBtn: {
    textTransform: 'unset',
    color: 'inherit',
    '&:hover': {
      backgroundColor: 'unset',
    },
  },
  contactBtnText: {
    padding: 0,
  },
  highlighted: {
    position: 'absolute',
    content: '""',
    backgroundColor: theme.color.grey_mist,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
});
